<div class="dash">
    <div class="row">
        <div class="col-12">
            <div class="dash-card no-padding">
                <ng-container *ngIf="!loading">
                    <!-- <app-back-button></app-back-button> -->
                </ng-container>

                <div
                    class=" dash-card-header d-flex align-items-start justify-content-between">
                    <h2>Agentes para prestador de serviços</h2>

                    <app-button (onClick)="addAgentsToggle(true)"
                        class="add-button" [disabled]="loading"
                        *ngIf="permissionObj.canAdd">
                        <svg-icon src="assets/images/icon-add.svg"
                            class="mr-2 mb-1"></svg-icon>
                        Adicionar
                        agente
                    </app-button>
                </div>

                <div class="dash-card-body padding-container"
                    style="overflow: visible;">
                    <ng-container *ngIf="loading">
                        <table #table class="bordered">
                            <tbody>
                                <tr *ngFor="let number of [0,1,2,3,4,5,6]">
                                    <td>
                                        <ngx-skeleton-loader [theme]="{
                                            height: '16px',
                                            width: '200px',
                                        marginBottom:'0'
                                          }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td class="item-number">
                                        <ngx-skeleton-loader [theme]="{
                                        height: '16px',
                                        width: '40px',
                                        marginBottom:'0',
                                        marginLeft: 'auto'
                                      }">
                                        </ngx-skeleton-loader>
                                    </td>
                                    <td>
                                        <div
                                            style="display: flex; gap: 8px; justify-content: flex-end;">
                                            <ngx-skeleton-loader [theme]="{
                                                height: '16px',
                                                width: '16px',
                                                marginBottom:'0',
                                                borderRadius: '0'
                                              }">
                                            </ngx-skeleton-loader>
                                            <ngx-skeleton-loader [theme]="{
                                                height: '16px',
                                                width: '16px',
                                                marginBottom:'0',
                                                borderRadius: '0'
                                              }">
                                            </ngx-skeleton-loader>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </ng-container>

                    <table class="bordered" aria-describedby="Agents table"
                        *ngIf="!loading">
                        <thead>
                            <tr>
                                <th>Agente</th>
                                <th class="text-right">Qtde. de Vínculos</th>
                                <th></th>
                            </tr>
                        </thead>

                        <tbody>
                            <tr *ngFor="let agent of agents">
                                <td>{{agent.label}}</td>
                                <td class="text-right">
                                    <ng-container
                                        *ngIf="agent.users">{{agent.users.length}}</ng-container>
                                </td>
                                <td>
                                    <div class="dash-card-item-buttons">
                                        <app-tooltip text="Editar"
                                            position="top"
                                            *ngIf="permissionObj.canChange">
                                            <button class="dash-item-button"
                                                (click)="setAgent(agent)">
                                                <svg-icon
                                                    src="assets/images/icon-edit.svg"></svg-icon>
                                            </button>
                                        </app-tooltip>
                                        <app-spacer [right]="8"
                                            *ngIf="permissionObj.canChange"></app-spacer>
                                        <app-tooltip
                                            [text]="(agent.users && agent.users.length > 0) ? 'Não é possível excluir agente com vínculos' : 'Excluir'"
                                            position="top"
                                            *ngIf="permissionObj.canChange">
                                            <button class="dash-item-button"
                                                (click)="openDeleteModal(agent)"
                                                [disabled]="agent.users && agent.users.length > 0">
                                                <svg-icon
                                                    src="assets/images/icon-trash.svg"></svg-icon>
                                            </button>
                                        </app-tooltip>

                                    </div>
                                </td>
                            </tr>

                            <tr *ngIf="agents.length === 0">
                                <td>Nenhum agente adicionado</td>
                            </tr>

                        </tbody>
                        <app-spacer [bottom]="28"></app-spacer>
                    </table>
                </div>
            </div>
        </div>
    </div>
</div>

<app-side-modal [active]="addAgents"
    [title]="agent ? 'Atualizar agente' : 'Novo agente'"
    (onClose)="addAgentsToggle(false)">
    <ng-container *ngIf="addAgents">
        <form class="row" [formGroup]="agentsForm">
            <div class="col-12">
                <app-input label="Nome" [group]="agentsForm" controlName="name">
                </app-input>
                <app-spacer [bottom]="32"></app-spacer>
            </div>

            <div class="col-12">
                <div class="d-flex justify-content-between align-items-center">
                    <app-button (onClick)="addAgentsToggle(false)"
                        [phantom]="true">
                        Cancelar
                    </app-button>
                    <app-button (onClick)="addAgent()"
                        [disabled]="agentsForm.invalid || savingAgent"
                        [loading]="savingAgent" class="add-button">
                        Concluir
                    </app-button>
                </div>
            </div>
        </form>
    </ng-container>


</app-side-modal>

<!-- Carbon Warning Modal -->
<app-carbon-warning-modal [active]="showDeleteModal"
    [title]="getDeleteModalTitle()" [message]="getDeleteModalMessage()"
    [confirmText]="getDeleteConfirmText()" [cancelText]="getDeleteCancelText()"
    [confirmAction]="confirmDeleteAgent.bind(this)"
    [cancelAction]="closeDeleteModal.bind(this)" (onClose)="closeDeleteModal()">
</app-carbon-warning-modal>

<!-- Loading Spinner -->
<app-loading-spinner [active]="deletingAgent"></app-loading-spinner>